import React from 'react';
import { useStoreon } from 'storeon/react';
import { LeroyMerlinStoreIcon, EnvelopeSimpleIcon } from '@fronton/icons-react';
import {
  CATALOG_PAGE_PATH,
  SERVICES_PAGE_PATH,
  APRO_PAGE_PATH,
  CLIENT_SUPPORT_PAGE_PATH,
} from 'common/constants';
import { Drawer, DrawerHeader, DrawerContent, DrawerFooter } from 'common/components/left-drawer';
import { HeaderModelData } from 'types/model';
import { headerBackBtn } from 'components/header/styles/common';
import { getIsNewTheme } from 'selectors';
import { UseMenuStateReturnType, useSideMenuAnalyticsEvent } from '../../hooks';
import { footerRoot, secondaryItemsRoot, footer, content } from './styles';
import { PrimaryMenuItem } from './primary-menu-item';
import { SecondaryMenuItem } from './secondary-menu-item';
import { MenuContentLayer } from '../menu-content-layer';
import { LemanaPro, Pro, LemanaStores } from '../../../icons';
import { State } from '../../../../store/types';

export interface MainMenuProps extends UseMenuStateReturnType {
  model: HeaderModelData;
}

export const MainMenu = (props: MainMenuProps) => {
  const { show, onMenuClose, model } = props;
  const { shops } = model.header;

  const onCatalogClick = useSideMenuAnalyticsEvent('products');
  const onServicesClick = useSideMenuAnalyticsEvent('services');
  const onShopsClick = useSideMenuAnalyticsEvent('shops');
  const onClientServiceClick = useSideMenuAnalyticsEvent('clientService');

  const { cookies } = useStoreon<State>('cookies');
  const isNewTheme = getIsNewTheme(cookies);

  return (
    <Drawer onClose={onMenuClose} show={show}>
      <DrawerHeader title="" onClickBack={onMenuClose} className={headerBackBtn} />
      <DrawerContent className={content}>
        <PrimaryMenuItem
          href={CATALOG_PAGE_PATH}
          title="Товары"
          subtitle="Всё для стройки, ремонта и обустройства"
          data-qa="catalog-link"
          onClick={onCatalogClick}
        />
        <PrimaryMenuItem
          href={SERVICES_PAGE_PATH}
          title="Услуги"
          subtitle="Проектирование, установка, ремонт под ключ и др."
          data-qa="services-page-link"
          onClick={onServicesClick}
        />
        <MenuContentLayer vertical className={secondaryItemsRoot}>
          <SecondaryMenuItem
            href={shops}
            title="Магазины"
            icon={isNewTheme ? undefined : LeroyMerlinStoreIcon}
            customIcon={isNewTheme ? <LemanaStores /> : undefined}
            onClick={onShopsClick}
            data-qa="store-link"
          />
          <SecondaryMenuItem
            href={APRO_PAGE_PATH}
            title="Бизнес-клиентам"
            customIcon={isNewTheme ? <LemanaPro /> : <Pro />}
            onClick={onShopsClick}
            data-qa="store-link"
          />
        </MenuContentLayer>
      </DrawerContent>
      <DrawerFooter className={footer}>
        <div className={footerRoot}>
          <SecondaryMenuItem
            href={CLIENT_SUPPORT_PAGE_PATH}
            title="Клиентская поддержка"
            icon={EnvelopeSimpleIcon}
            data-qa="client-support-link"
            onClick={onClientServiceClick}
          />
        </div>
      </DrawerFooter>
    </Drawer>
  );
};
